// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vgQZw","left":"styles_left__3aXHY","desktopActions":"styles_desktopActions__3lQPV","title":"styles_title__1xkbU"};